import React from 'react'
import { DSSpacer, DSText } from '@zoe/ds-web'

export interface FieldErrorProps {
  children: React.ReactNode
}

export const FieldError: React.FC<FieldErrorProps> = React.memo(({ children }) => (
  <>
    <DSSpacer size={8} direction="vertical" />
    <DSText variant="fluid-paragraph-200" color="error">
      {children}
    </DSText>
  </>
))
